var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwiperPregnancyActiveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-113.93 -38.576)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(113.93 38.576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5,1.785a15,15,0,1,1-15,15A15,15,0,0,1,16.5,1.785Z",
    transform: "translate(-1.497 -1.785)",
    fill: "#bf67c3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-26.393 -16.311)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(146.322 61.554)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.367,76.446h0a2,2,0,0,0-2.472-.718l-.779.346s-.208-2.371-1.884-2.429h-.466",
    transform: "translate(-151.141 -68.044)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.151,79.646l.624,1.363a1.5,1.5,0,0,0,1.987.74h0l.682-.312",
    transform: "translate(-150.903 -70.368)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.08,78.7l1.215-2.2a4.55,4.55,0,0,0,.477-3.251c-.025-.1-.053-.2-.086-.293a3.108,3.108,0,0,0-1.618-1.733,3.922,3.922,0,0,0-3.721.879h0a.75.75,0,0,0-.994-.37l-.157.072a1.5,1.5,0,0,0-.768,1.922c.417,1.068,1.127,2.376,2.116,2.41",
    transform: "translate(-146.322 -67.031)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.79,68.238a4.435,4.435,0,1,1,6.984,4.287,1.368,1.368,0,0,0-.581,1.024c-.017.319-.032.59-.037.62a7.055,7.055,0,0,1-1.14,2.68,10.226,10.226,0,0,1-6.493,4.164,7.1,7.1,0,0,1-4.229-.358,4.317,4.317,0,0,1-2.551-3.041A5.582,5.582,0,0,1,150,73.476l1.2-1.485",
    transform: "translate(-147.242 -64.504)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M150.9,57.35c3.268,0,4.329,1.672,4.329,4.343s-1.4,4.272,0,6.943",
    transform: "translate(-1.279 -1.48)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwiperPregnancyActiveIcon);
export default __webpack_public_path__ + "static/media/swiper_pregnancy_active_icon.d883150c.svg";
export { ForwardRef as ReactComponent };